import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  LoadScript,
  StandaloneSearchBox,
} from "@react-google-maps/api";
import axiosConfig from "../../Service/axiosConfig";

const librariesArray = ["places"];

const AddressModal = ({ setFormData, formData, readOnly }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchBox, setSearchBox] = useState(null);
  const [key, setKey] = useState("");
  const [loadingKey, setLoadingKey] = useState(true);

  const defaultLocation = { lat: 17.38714, lng: 78.491684 };

  const onLoad = (ref) => {
    setSearchBox(ref);
  };

  const extractPincode = async (latitude, longitude) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${key}`
      );
      const data = await response.json();
      if (data.results?.length > 0) {
        const components = data.results[0].address_components;
        for (let comp of components) {
          if (comp.types.includes("postal_code")) {
            return comp.long_name;
          }
        }
      }
      return "";
    } catch (error) {
      console.error("Error extracting pincode:", error);
      return "";
    }
  };

  const onPlacesChanged = async () => {
    const places = searchBox.getPlaces();
    if (!places || places.length === 0) return;

    const place = places[0];
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const formattedAddress = place.formatted_address;

    const pincode = await extractPincode(lat, lng);

    setSelectedLocation({ lat, lng });
    setFormData({
      ...formData,
      address: formattedAddress,
      latitude: lat,
      longitude: lng,
      pincode: pincode || "",
      landmark: "",
    });
  };

  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    setSelectedLocation({ lat, lng });

    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${key}`;
    fetch(geocodeUrl)
      .then((res) => res.json())
      .then((data) => {
        if (data.results?.length > 0) {
          const formattedAddress = data.results[0].formatted_address;
          const components = data.results[0].address_components;
          let pincode = "";
          for (let comp of components) {
            if (comp.types.includes("postal_code")) {
              pincode = comp.long_name;
              break;
            }
          }

          setFormData({
            ...formData,
            latitude: lat,
            longitude: lng,
            address: formattedAddress,
            pincode: pincode,
          });
        }
      })
      .catch((err) => {
        console.error("Error on map click:", err);
      });
  };

  const GetKey = async () => {
    try {
      const response = await axiosConfig.get(`/masters/googlemapkey/`);
      if (response.data?.results?.length > 0) {
        setKey(response.data.results[0].key);
      }
    } catch (err) {
      console.error("Error fetching Maps key:", err);
    } finally {
      setLoadingKey(false);
    }
  };

  useEffect(() => {
    GetKey();
  }, []);
  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      console.log("Geolocation not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        setSelectedLocation({ lat, lng });

        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${key}`
          );

          const data = await response.json();

          if (data.results && data.results.length > 0) {
            let locality = "";
            let sublocality = "";
            let pincode = "";

            const components = data.results[0].address_components;

            for (let comp of components) {
              if (comp.types.includes("locality")) {
                locality = comp.long_name;
              }

              if (
                comp.types.includes("sublocality") ||
                comp.types.includes("sublocality_level_1")
              ) {
                sublocality = comp.long_name;
              }

              if (comp.types.includes("postal_code")) {
                pincode = comp.long_name;
              }
            }

            // 🔥 Build clean address manually
            const formattedAddress = `${sublocality || locality || ""}, ${pincode || ""}`;

            setFormData((prev) => ({
              ...prev,
              latitude: lat,
              longitude: lng,
              address: formattedAddress,
              pincode: pincode,
            }));
          }

        } catch (err) {
          console.error("Reverse geocode failed:", err);
        }
      },
      (error) => {
        console.error("Location permission denied:", error);
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    );
  };

  // useEffect(() => {
  //   if (key && !formData.latitude && !readOnly) {
  //     getCurrentLocation();
  //   }
  // }, [key]);
  useEffect(() => {
    // Auto-fill only when:
    // 1. Google key loaded
    // 2. Not in readOnly (edit mode)
    // 3. No latitude already present

    if (
      key &&
      !readOnly &&
      !formData.latitude &&
      !formData.longitude
    ) {
      getCurrentLocation();
    }
  }, [key, readOnly]);

  useEffect(() => {
    if (formData.latitude && formData.longitude) {
      setSelectedLocation({ lat: formData.latitude, lng: formData.longitude });
    } else {
      setSelectedLocation(defaultLocation);
    }
  }, [formData]);

  if (loadingKey) {
    return <div>Loading map…</div>;
  }

  return (
    <div>
      <LoadScript googleMapsApiKey={key} libraries={librariesArray}>
        <StandaloneSearchBox onLoad={onLoad} onPlacesChanged={onPlacesChanged}>
          <input
            type="text"
            placeholder="Search for a place"
            className="form-control mb-3"
          />
        </StandaloneSearchBox>

        <GoogleMap
          mapContainerStyle={{ width: "100%", height: "300px" }}
          center={selectedLocation || defaultLocation}
          zoom={13}
          onClick={readOnly ? null : handleMapClick}
          options={{
            disableDefaultUI: false,
            clickableIcons: false,
            draggable: !readOnly,
          }}
        >
          {selectedLocation && (
            <Marker position={selectedLocation}>
              <InfoWindow position={selectedLocation}>
                <div>
                  <b>Selected Location</b>
                </div>
              </InfoWindow>
            </Marker>
          )}
        </GoogleMap>
      </LoadScript>
    </div>
  );
};

export { AddressModal };
